import { render, staticRenderFns } from "./author-set.vue?vue&type=template&id=1bfcf928&scoped=true&"
import script from "./author-set.vue?vue&type=script&lang=js&"
export * from "./author-set.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfcf928",
  null
  
)

export default component.exports